<div class="imprint-content">
  <h1>{{ i18n.langString("imprint2") }}</h1>
  @for (item of imprintData; track item) {
    <p class="body-bold">{{ item.title }}</p>
    <p class="wrap-text">
      {{ item.content }}
    </p>
  }
</div>
<app-nav-button
  [whiteBG]="true"
  tabindex="0"
  svgIcon="icons:arrow-left"
  (keyup)="gotoLogin()"
  (clickEvent)="gotoLogin()"
  >{{ i18n.langString("back") }}
</app-nav-button>
<app-scroll-to-top></app-scroll-to-top>
